import { SVGProps, Ref, forwardRef } from 'react';

export const CrossCircleOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M11.159 10.17 8.988 7.997l2.17-2.171-.99-.99-2.17 2.171-2.171-2.17-.99.989 2.171 2.171-2.171 2.171.99.99 2.17-2.171 2.172 2.171z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M.5 8C.5 4.25 2.375.5 8 .5s7.5 3.75 7.5 7.5-1.875 7.5-7.5 7.5S.5 11.75.5 8m1.4 0c0-1.667.42-3.184 1.316-4.26C4.076 2.709 5.524 1.9 8 1.9s3.925.809 4.784 1.84C13.68 4.816 14.1 6.333 14.1 8s-.42 3.184-1.316 4.26c-.86 1.031-2.308 1.84-4.784 1.84s-3.925-.809-4.784-1.84C2.32 11.184 1.9 9.667 1.9 8"
                fill="currentColor"
            />
        </g>
    </svg>
));
CrossCircleOutlinedSize16Glyph.displayName = 'CrossCircleOutlinedSize16Glyph';
